import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBookmark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBookmark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '17c52360ac40b8f5c5e2d9acab6f0cef9ed8362d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '64b00a81b4890e2e25bd1b0b0d68177db2f3ff06', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '09b898e57b33635277770e80dbc927fcb9ef6c8c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 4.5v12.11l-4.16-3.77a.5.5 0 0 0-.68 0L6.5 16.61V4.5zM5.5 3a.5.5 0 0 0-.5.5v15.6a.4.4 0 0 0 .67.29L11 14.56l5.33 4.83a.4.4 0 0 0 .67-.29V3.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-bookmark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bookmark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bookmark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBookmark$1);
            }
            break;
    } });
}

const CosmosIconBookmark = CosmosIconBookmark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBookmark, defineCustomElement };
